import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';
import { TranslateModule } from "@ngx-translate/core";

import { SharedModule } from "../../../../modules/shared.module";

import { FooterComponent } from '../components/footer/footer.component';
import { FooterMenuComponent } from '../components/footer-menu/footer-menu.component';
import { HeaderComponent } from '../components/header/header.component';
import { ActorsComponent } from '../components/actors/actors.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        IonicModule,
        SharedModule
    ],
    exports: [
        FooterComponent,
        HeaderComponent,
        FooterMenuComponent,
        ActorsComponent
    ],
    declarations: [
        FooterComponent,
        HeaderComponent,
        FooterMenuComponent,
        ActorsComponent
    ]
})
export class SharedCustomModule { }
